import { render, staticRenderFns } from "./EditPermissionModal.vue?vue&type=template&id=490ef666&scoped=true"
import script from "./EditPermissionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPermissionModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EditPermissionModal.vue?vue&type=style&index=0&id=490ef666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490ef666",
  null
  
)

export default component.exports